import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'hooks/useTranslation';
import { HeaderSectionIcon } from 'components';
import HelpLink from 'components/HelpLink';

const WebsiteListHeader = ({ title }) => {
  const { getTranslation } = useTranslation('WEBSITES');
  const { t } = getTranslation();

  return (
    <div className='flex flex-jc-sb WebsiteListHeaderWrapper'>
      <div className='workspaces__header__title flex flex-colgap-8'>
        <HeaderSectionIcon />

        <div>
          <h1 className='main_section_header_title'>{title}</h1>
          <p className='main_section_header_desc'>{t('HONOR_TEXT')}</p>
        </div>
      </div>
      <div className='workspaces__header__actions flex-noflex'>
        {/* <AddWebsiteModal /> */}
        <HelpLink text={t('DASHBOARD_HELP')} />
      </div>
    </div>
  );
};

WebsiteListHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default WebsiteListHeader;
